import { Outlet } from "react-router-dom";
import { ZodErrorBoundary } from "@/components/common/ZodErrorBoundary";

export default function RouteBoundaryLayout() {
  return (
    <ZodErrorBoundary>
      <Outlet />
    </ZodErrorBoundary>
  );
}
